import { render, staticRenderFns } from "./LiabilitiesMortgageYN.vue?vue&type=template&id=0534f685"
import script from "./LiabilitiesMortgageYN.vue?vue&type=script&lang=js"
export * from "./LiabilitiesMortgageYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports